import { dom } from '@omegagrid/core';
import { FormContainer } from "@omegagrid/form";
import { AppComponent, Application, ParsedComponentId, GridEditor } from '@reporting/rp-app-host';
import { Ticket } from '@reporting/rp-types/helpdesk';
import { Sidebar, TicketContainer } from './components';
import { NewTicketFormAdapter} from './adapters/newTicketFormAdapter';
import { EditTicketFormAdapter} from './adapters/editTicketFormAdapter';
import { TicketsGridEditorAdapter } from './adapters/ticketsGridEditorAdapter';

const createMainSidebar = (app: Application, componentId: ParsedComponentId) => {
	return dom.createElement<Sidebar>('rp-helpdesk-sidebar');
}

const createTicketGridEditor = (app: Application, componentId: ParsedComponentId) => {
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	component.adapter = new TicketsGridEditorAdapter();
	return component;
}

const createNewTicketForm = (app: Application, componentId: ParsedComponentId) => {
	const component = dom.createElement<FormContainer>('og-form-container');
	const adapter = new NewTicketFormAdapter();
	adapter.id = componentId.ids[1] ? parseInt(componentId.ids[1]) : null;
	component.adapter = adapter;
	component.addEventListener('form.save', () => (app.host.components.components.get('helpdesk') as Sidebar)?.refresh());
	return component as unknown as AppComponent;
}

const createEditTicketForm = async (app: Application, componentId: ParsedComponentId) => {
	const ticket = await app.container.ms('helpdesk').get<Ticket>(`tickets/${componentId.ids[1]}`);
	const component = dom.createElement<FormContainer>('og-form-container');
	const adapter = new EditTicketFormAdapter(ticket);
	component.adapter = adapter;
	component.addEventListener('form.save', () => {
		(app.host.components.components.get('helpdesk') as Sidebar)?.refresh();
		try {
			(app.container.host.components.components.get(`helpdesk-ticket-${ticket.id_request}`) as TicketContainer)?.refresh();
		} catch (e) {}
	});
	return component as unknown as AppComponent;
}

const createTicketContainer = async (app: Application, componentId: ParsedComponentId) => {
	const ticket = await app.container.ms('helpdesk').get<Ticket>(`tickets/${componentId.ids[1]}`);
	const component = dom.createElement<TicketContainer>('rp-helpdesk-ticket-container');
	component.ticket = ticket;
	return component as unknown as AppComponent;
}

export const componentFactories = new Map<string, (app: Application, componentId: ParsedComponentId) => AppComponent|Promise<AppComponent>>([
	['helpdesk', createMainSidebar],
	['tickets', createTicketGridEditor],
	['newTicketForm', createNewTicketForm],
	['editTicketForm', createEditTicketForm],
	['ticket', createTicketContainer],
]);
